<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TruckAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            ">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                    Mater Truck Lumpsum Edit
                  </h6>
                  <!-- <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button> -->
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <!-- <div v-if="isLoading" class="d-flex align-items-center">
                    <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div> -->
                  <!--end::loading-data-->

                  <form class="forms-sample" ref="formElement" @submit.prevent="submitData" method="POST">
                    <div class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "></div>

                    <div class="row">
                      <div class="col-lg-6">
                            <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Company</label>
                          </div>
                          <div class="col-lg-8">
                          

                            <multiselect v-model="company" :options="fetchCompany" @input="changeCompany" @search-change="asyncSearchCompany"
                            :custom-label="customLabel" placeholder="Type to search" track-by="name"
                              label="code"><span slot="noResult">Oops! No elements found. Consider changing the
                                search query.</span></multiselect>

                        

                            <div v-if="errors.project">
                              <div v-for="error in errors.project" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      

                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                              $t("type_truck") }}*</label>
                          </div>
                          <div class="col-lg-8">
                           
                            <multiselect v-model="typeTruck" :options="fetchTypeTruck" @input="changeTypeTruck" @search-change="asyncLoadTypeTruck"
                             placeholder="Type to search" track-by="type_truck"
                              label="type_truck"><span slot="noResult">Oops! No elements found. Consider changing the
                                search query.</span></multiselect>

                            <div v-if="errors.type_truck_id">
                              <div v-for="error in errors.type_truck_id" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Billable Method </label>
                          </div>
                          <div class="col-lg-8">
                          <multiselect @search-change="asyncSearchBillabkeTarif" v-model="billableTariff" 
                          name="Billabel Tarif" :options="fetchBillableTariff" placeholder="Please Select"
                          track-by="tariff_name" label="tariff_name">
                          <span slot="noResult">-</span>
                        </multiselect>

                            <div v-if="errors.billabelMethod">
                              <div v-for="error in errors.billabelMethod" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                      
                       

                      

                      

                      


                       

                        

                      </div>

                      <div class="col-lg-6">
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">
                              Customer Name</label>
                          </div>
                          <div class="col-lg-8">
                            <input type="text" class="form-control" id="customer_name" 
                              v-model="forms.customer_name" required readonly />
                            <div v-if="errors.customer_name">
                              <div v-for="error in errors.customer_name" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>



                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">SAP Code </label>
                          </div>
                          <div class="col-lg-8">
                            <input type="text" class="form-control" id="sap_code" 
                              v-model="forms.sap_code" readonly />
                            <div v-if="errors.sap_code">
                              <div v-for="error in errors.sap_code" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        
                       


                       




                        
                        <!--div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label"
                              style="padding-left: 25px"
                              >{{ $t("unit_allocation") }}</label
                            >
                          </div>
                          <div class="col-lg-8">
                            <input
                              type="text"
                              class="form-control"
                              id="unit_allocation"
                              :placeholder="$t('unit_allocation')"
                              v-model="forms.unit_allocation"
                            />
                            <div v-if="errors.unit_allocation">
                              <div
                                v-for="error in errors.unit_allocation"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div-->


                       
                        


                        


                      </div>
                    </div>

                    <div class="row">
                      
                      
                      <div class="row align-items-center mb-2">
                        <div class="col-lg-6">
                          <h5 class="mb-0">Detail Truck</h5>
                        </div>
                        <div class="col-lg-6 text-right">
                          <span class="btn btn-success mb-2" @click="addRow">
                              <i class="fa fa-plus"></i>
                            </span>
                        </div>
                      </div>
                        

                         <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Action</th>
                            <th>Truck No / No Lambung</th>
                            <th>Vehicle No</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in truckDetails" :key="row.id">
                            <td>{{ index + 1 }}</td>
                            <td>
                              <div v-if="row.isEditing==true">
                                <span class="btn btn-success btn-sm" style="margin-right: 5px;" @click="confirmRow(index)">
                                  <i class="fa fa-check"></i>
                                </span>
                                <span class="btn btn-danger btn-sm" @click="showDeleteConfirm(index)">
                                  <i class="fa fa-close"></i>
                                </span>
                              </div>
                              <div  v-if="row.isEditing==false">
                                <span class="btn btn-warning btn-sm" style="margin-right: 5px;" @click="editRow(index)">
                                  <i class="fa fa-edit"></i>
                                </span>
                                <span class="btn btn-danger btn-sm" @click="showDeleteConfirm(index)">
                                  <i class="fa fa-trash"></i>
                                </span>
                              </div>
                            </td>
                            <td>
                              <input
                                v-if="row.isEditing || row.isNew"
                                type="text"
                                class="form-control"
                                v-model="row.truck_no"
                                @input="row.truck_no = row.truck_no.replace(/[^A-Za-z0-9_]/g, '')"
                              />
                              <span v-else>{{ row.truck_no }}</span>
                            </td>
                            <td>
                              <!-- <select
                                v-if="row.isEditing || row.isNew"
                                class="form-control"
                                v-model="row.vehicle_no"
                              >
                                <option v-for="option in vehicleOptions" :key="option" :value="option">
                                  {{ option }}
                                </option>
                              </select> -->

                              <multiselect v-if="row.isEditing || row.isNew" @search-change="asyncLoadTruck" v-model="row.vehicle_no" 
                                name="Vehicle_no" :options="fetchVehicleNo" placeholder="Please Select"
                                track-by="vehicle_no" label="vehicle_no">
                                <span slot="noResult">-</span>
                              </multiselect>


                              <span v-else>{{ row.vehicle_no.vehicle_no }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                     
                    </div>

                    <div class="card-footer">
                      <button class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        " @click="backForm" type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button v-if="!isLoading" class="btn btn-primary float-end btn-sm" type="submit">
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>

                      <div v-if="isLoading" class="d-flex align-items-center">
                        <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                        <strong>{{ $t("loadingTxt") }}...</strong>
                      </div>

                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
// import Datepicker from "vuejs-datepicker";
// import moment from "moment";
import multiselect from "vue-multiselect";

export default {
  name: "TruckAdd",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,

    multiselect: multiselect
  },
  data() {
    return {
      billabelMethod:"",
      customer_code:"",
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchBranch: [],
      fetchBillableMethod:[],
      billableTariff:"",
      fetchBillableTariff:[],
      branch: [],
      fetchTruckBrand: [],
      fetchUnitAllocation: [],
      fetchBillable: [],
      company: '',
      fetchOwnersShip: [],
      fetchCarrier: [],
      fetchTypeTruck: [],
      fetchCompany: [],
      fetchDriver: [],
      truck_category: [],
      fetchTruckCategory: [],
      driver: [],
      truckBrand: [],
      unitAllocation: [],
      typeTruck: [],
      billable: [],
      ownersShip: [],
      highlighted: {
        dates: [ // Highlight an array of dates
          new Date(),
        ],
      },

      truckDetails: [],
      deleteIndex: null,
      typeTruck_: "L300_BOX", 
      vehicleOptions: [],
        // L300_BOX: [
        //   "B9081BEV", "B9082BEQ", "B9083BER", "B9084BET",
        //   "B9085BEY", "B9086BES", "B9087BEJ", "B9088BEL",
        //   "B9088BEP", "B9090BEA",
        // ],
        // tambahkan tipe lain jika perlu
      

      permision_role: [],
      userData: "",
      companyCode: "",
      images: '',
      images_temporary: null,
      fetchVehicleNo:[],
      forms: {
        images: "",
        truck_model: "",
        truck_status: "IDLE",
        engine_number: "",
        vin: "",
        name_of_owner: "",
        device_id: "",
        manufacture_year: "",
        purchased_year: "",
        ac_category: "",
        box_category: "",
        project: "",
        driver_id: "",
        carrier: "",
        gps_vendor: "TIDAK ADA",
      },
      fetchPic:[],
    };
  },
  watch: {},
  methods: {
    loadPic() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=mstpic`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchPic = response.data.datas;
      });
    },
    removeImages() {
      this.$refs.images.value = "";
      this.images_temporary = null;
    },

    handleFileUpload(event) {
      this.images = event.target.files[0];
      this.images_temporary = URL.createObjectURL(this.images);
    },

    resetForm() {
      this.removeImages();
      this.forms = "";
    },

    backForm() {
      window.location.href = "/master-truck-lumpsum";
    },


  
    addRow() {
      this.truckDetails.push({
        id: Date.now(),
        truck_no: "",
        vehicle_no: "",
        isNew: true,
        isEditing: true,
      });
    },
    confirmRow(index) {
      const row = this.truckDetails[index];
      row.isNew = false;
      row.isEditing = false;
    },
    editRow(index) {
      this.truckDetails[index].isEditing =  !this.truckDetails[index].isEditing;
    },
    // showDeleteConfirm(index) {
    //   this.deleteIndex = index;
    // },
    cancelDelete() {
      this.deleteIndex = null;
    },
    deleteRow(index) {
      this.truckDetails.splice(index, 1);
      this.deleteIndex = null;
    },

    changevehicle_no(ev){

       const baseURI =
        this.$settings.endPoint + `rm-master-truck-lumpsum/truck-no?company_id=${this.company.company_id}&billable_method=${ev.tariff_name}&type_truck=${this.typeTruck.type_truck}`;
      return this.$http.get(baseURI).then((response) => {
    
        var fetchTruck = response.data.datas;
        for (let index = 0; index < fetchTruck.length; index++) {
        
          this.vehicleOptions.push(fetchTruck[index].vehicle_no)
          
        }
        console.log(this.vehicleOptions);
      });
    },

    loadBranch() {
      const baseURI = this.$settings.endPointCt + `branch/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchBranch = response.data.datas.data;
      });
    },

    asyncLoadBranch(ev) {
      const baseURI = this.$settings.endPointCt + `branch?branch_name=` + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchBranch = response.data.datas.data;
      });
    },


    loadCompanyNotLinc() {
      const baseURI =
        this.$settings.endPoint + `company/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },



    // loadTruck() {
    //   const baseURI =
    //     this.$settings.endPoint + `rm-master-truck-lumpsum/truck-no?company_id=${this.company.id}&billable_method=${this.billableTariff.tariff_name}&type_truck=${this.typeTruck.type_truck}`;
    //   return this.$http.get(baseURI).then((response) => {
    //     // this.fetchTruck = response.data.datas;
    //   });
    // },

    asyncSearchCompanyNotLinc(ev) {
      const baseURI =
        this.$settings.endPoint +
        "company/select?code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },


    loadDriver() {
      const baseURI = this.$settings.endPointCt + `master-driver`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
      });
    },

    loadCarrier() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=carer`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCarrier = response.data.datas;
      });
    },


    loadCompany() {
      const baseURI = this.$settings.endPoint + "company/dropdown-company";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },


    customLabel(option) {
      // Sesuaikan label berdasarkan kombinasi code dan name
      return `${option.code} - ${option.name}`;
    },

    customDriverLabel(option) {
      return `${option.driver_id} - ${option.driver_name}`;
    },

    showDeleteConfirm(index) {
      const row = this.truckDetails[index];

      this.$swal.fire({
        title: 'Apakah anda yakin akan menghilangkan record ini',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'BATAL',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#d33',
      }).then((result) => {
        if (result.isConfirmed) {
          this.truckDetails.splice(index, 1);
          this.$swal.fire({
            title: 'Terhapus!',
            text: `Truck No ${row.truck_no} telah dihapus.`,
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
          });
        }
      });
    },



    asyncSearchCompany(ev) {
      this.fetchCompany = [];
      const baseURI = this.$settings.endPoint + "company/dropdown-company?code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },


    loadCBillabel() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=bunit`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchBillable = response.data.datas;
      });
    },


    loadBrand() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=trMerk`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchTruckBrand = response.data.datas;
      });
    },

    asyncLoadDriver(ev) {
      const baseURI = this.$settings.endPointCt + `master-driver?driver_name=` + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
        //console.log(this.fetchDriver);
      });
    },

    changeCompany(ev){
      this.forms.sap_code=ev.sap_code;
      this.forms.customer_name=ev.name;
      this.forms.customer_code=ev.code;
      this.loadBillableTariff();
    },


     loadBillableTariff() {
      const baseURI =
        this.$settings.endPoint +
        `rm-billable-tariff?customer_code=${this.forms.customer_code}`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchBillableTariff = response.data.datas.data;
        this.fade(false);
      });
    },

    asyncSearchBillabkeTarif(ev) {
      const baseURI =
        this.$settings.endPoint +
        `rm-billable-tariff?customer_code=${this.forms.customer_code}&tariff_name=${ev}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchBillableTariff = response.data.datas.data;
      });
    },

    asyncLoadCarrier(ev) {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=` + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
        //console.log(this.fetchDriver);
      });
    },

    loadTypeTruck() {
      const baseURI = this.$settings.endPointCt + `type-truck`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchTypeTruck = response.data.datas.data;
      });
    },

    asyncLoadTypeTruck(ev) {
      const baseURI = this.$settings.endPointCt + `type-truck?type_truck=` + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchTypeTruck = response.data.datas.data;
      });
    },


    loadCategoryTruck() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=truca`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchTruckCategory = response.data.datas;
      });
    },



    loadData(id) {
      const baseURI =
        this.$settings.endPoint + "rm-master-truck-lumpsum/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        console.log(response);
        this.forms = response.data.datas;

        this.loadTruck(this.forms.type_truck);
        this.company={
            company_id:this.forms.company_id,
            name:this.forms.customer_name,
            code:this.forms.customer_code,
            sap_code:this.forms.sap_code
        }
        this.typeTruck={
            type_truck:this.forms.type_truck
        }
        this.billableTariff={
            tariff_name:this.forms.billable_method
        }


        var truckDetails=this.forms.detail;
        for (let index = 0; index < truckDetails.length; index++) {
           this.truckDetails.push({
                id: truckDetails[index].rm_master_truck_lumpsum_id,
                truck_no: truckDetails[index].truck_no,
                vehicle_no: {vehicle_no:truckDetails[index].vehicle_no},
                isNew: false,
                isEditing: false,
            });
                    
        }

         
            
           const baseURI =
                this.$settings.endPoint + `rm-master-truck-lumpsum/truck-no?company_id=${this.company.company_id}&billable_method=${this.forms.billable_method}&type_truck=${this.typeTruck.type_truck}`;
            return this.$http.get(baseURI).then((response) => {
            
                var fetchTruck = response.data.datas;
                for (let index = 0; index < fetchTruck.length; index++) {
                
                this.vehicleOptions.push(fetchTruck[index].vehicle_no)
                
                }
                console.log(this.vehicleOptions);
            
            });

          
       
      });
    },



    changeTypeTruck(ev){
      this.loadTruck(ev.type_truck);
    },


    loadTruck(type) {
      const baseURI = this.$settings.endPointCt + `master-truck?type_truck=${type}`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchVehicleNo = response.data.datas.data;
      });
    },

    asyncLoadTruck(ev) {
      const baseURI = this.$settings.endPointCt + `master-truck?type_truck=${this.typeTruck.type_truck}&vehicle_no=${ev}`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchVehicleNo = response.data.datas.data;
      });
    },


    // asyncLoadCategoryTruck(ev) {
    //   const baseURI = this.$settings.endPointCt + `type-truck?type_truck=` + ev;

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchTruckCategory= response.data.datas.data;
    //   });
    // },

    submitData() {

        var detail=[];
        for (let index = 0; index < this.truckDetails.length; index++) {
            detail.push({
            truck_no:this.truckDetails[index].truck_no,
            vehicle_no:this.truckDetails[index].vehicle_no.vehicle_no,
            })
        }

    var params = this.$onBehind(this.$route.params.id);
      this.isLoading = true;
      this.fade(true);
      var formData={
          "company_id": this.company.company_id,
          "customer_name":  this.forms.customer_name,
          "customer_code": this.forms.customer_code,
          "sap_code": this.forms.sap_code,
          "billable_method": this.billableTariff.tariff_name,
          "type_truck": this.typeTruck.type_truck,
          "detail": detail
      }
      const baseURI = this.$settings.endPoint + "rm-master-truck-lumpsum/update/"+params;
      this.$http
        .patch(baseURI, formData)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.isLoading = false;
            //this.resetForm();
            this.errors = [];
            //console.log(response.data.datas.user_id);
            //var params = this.$onRandom(response.data.datas.master_truck_id);
            // window.location.href =
            //   "/truck/detail/" + params + "?status=200&msg=Successfully";
            this.success('Berhasil');
          } else {
            this.isLoading = false;
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterTruckController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },



    loadUnitAlocation() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=tralloc`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchUnitAllocation = response.data.datas;
      });
    },

    loadOwnerShip() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=trowner`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchOwnersShip = response.data.datas;
      });
    },


    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {
    this.loadBranch();
    this.loadTypeTruck();
    this.loadDriver();
    this.loadCarrier();
    this.loadCategoryTruck();
    this.loadBrand();
    this.loadCompany();
    this.loadUnitAlocation()
    this.loadOwnerShip()
    this.loadPic();
    //this.loadBillableTariff();


    // this.fetchUnitAllocation.push(
    //   {
    //     unit_allocation_id: "1",
    //     unit_allocation_name: "ACTIVE",
    //   },
    //   {
    //     unit_allocation_id: "2",
    //     unit_allocation_name: "INACTIVE",
    //   },
    //   {
    //     unit_allocation_id: "3",
    //     unit_allocation_name: "SOLD",
    //   },
    //   {
    //     unit_allocation_id: "4",
    //     unit_allocation_name: "TERMINATED",
    //   },
    // );

    // this.fetchOwnersShip.push(
    //   {
    //     ownership_id: "1",
    //     ownership_name: "OWN"
    //   },
    //   {
    //     ownership_id: "2",
    //     ownership_name: "OPL"
    //   },
    //   {
    //     ownership_id: "3",
    //     ownership_name: "LAUTAN LUAS"
    //   },
    //   {
    //     ownership_id: "4",
    //     ownership_name: "VENDOR"
    //   },
    //   {
    //     ownership_id: "5",
    //     ownership_name: "ILO"
    //   },


    // );

  },
  mounted() {
    this.fetchIt();
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params);

    this.loadCBillabel();
    this.loadCompany()
    const formElement = this.$refs.formElement;
    if (formElement) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
            const inputs = formElement.querySelectorAll('.multiselect__input');
            inputs.forEach(input => {
              input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
            });
          }
        });
      });

      const inputs = formElement.querySelectorAll('.multiselect__input');
      inputs.forEach(input => {
        observer.observe(input, { attributes: true });
      });
    }
  },
};
</script>
<style scoped></style>